import { PERMISSIONS } from "@/rbac/permissions.js";
import { ACCESS_LEVELS } from "@/rbac/accessLevels.js";

const VIEW_PERMISSIONS = [PERMISSIONS.ROLE_BMS_SUPERUSER];

const EDIT_PERMISSIONS = [PERMISSIONS.ROLE_BMS_SUPERUSER];

export const ADMINISTRATION_PERMISSIONS = {
  [ACCESS_LEVELS.VIEW]: VIEW_PERMISSIONS,
  [ACCESS_LEVELS.EDIT]: EDIT_PERMISSIONS,
};
